export default __webpack_public_path__ + "static/media/shared.4c009d25.svg";